import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ServicesPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('services');

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold mb-6">خدماتي الاحترافية</h1>
          <p className="text-xl max-w-3xl mx-auto">
            أقدم مجموعة متنوعة من الخدمات الاستشارية والتطويرية للمشاريع والعلامات التجارية
          </p>
          <div className="mt-8 flex justify-center">
            <div className="bg-white rounded-lg p-1 inline-flex">
              <button
                onClick={() => setActiveTab('services')}
                className={`px-6 py-2 rounded-md text-sm font-medium transition-all duration-300 ${
                  activeTab === 'services'
                    ? 'bg-primary text-white'
                    : 'text-primary hover:bg-gray-100'
                }`}
              >
                الخدمات
              </button>
              <button
                onClick={() => setActiveTab('pricing')}
                className={`px-6 py-2 rounded-md text-sm font-medium transition-all duration-300 ${
                  activeTab === 'pricing'
                    ? 'bg-primary text-white'
                    : 'text-primary hover:bg-gray-100'
                }`}
              >
                الأسعار
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      {activeTab === 'services' && (
        <div className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {/* Service 1 */}
              <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition duration-300">
                <div className="text-primary text-4xl mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">استشارات ريادية بخبرة واقعية</h3>
                <p className="text-gray-600 mb-6">
                  قدّمت استشارات عملية في قطاع ريادة الأعمال والمشاريع، شملت التأسيس، والتخطيط، وتصميم النماذج القابلة للنمو، بالإضافة إلى بناء الهياكل التنظيمية والتجارية. كثير من هذه الاستشارات تضمنت أيضًا العمل على العلامة التجارية للمشروع منذ مراحله الأولى، بما يشمل تحديد الهوية، صياغة الرؤية، والتجهيز للظهور في السوق بأسلوب احترافي.
                </p>
                <Link to="/book-consultation" className="inline-block bg-primary text-white hover:bg-primary-dark px-6 py-3 rounded-md font-medium transition duration-300">
                  حجز استشارة
                </Link>
              </div>

              {/* Service 2 */}
              <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition duration-300">
                <div className="text-primary text-4xl mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">تأسيس وتطوير المشاريع والابتكار</h3>
                <p className="text-gray-600 mb-6">
                  أمتلك خبرة واسعة في تأسيس المشاريع من بداياتها، حيث أعمل على تحويل الأفكار إلى نماذج أعمال واقعية وقابلة للنمو. بالإضافة إلى ذلك، أُجري تحسينات وتطويرات على المشاريع القائمة، وأبتكر حلولًا للتحديات التي تواجهها، مع التركيز على الاستدامة والقابلية للتوسع.
                </p>
                <Link to="/book-consultation" className="inline-block bg-primary text-white hover:bg-primary-dark px-6 py-3 rounded-md font-medium transition duration-300">
                  طلب خدمة
                </Link>
              </div>

              {/* Service 3 */}
              <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition duration-300">
                <div className="text-primary text-4xl mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">بناء العلامات التجارية</h3>
                <p className="text-gray-600 mb-6">
                  أعمل على تصميم وبناء العلامات التجارية من الصفر، بدءًا من تحديد الهوية والقيم، مرورًا بصياغة الرؤية والرسالة، وصولًا إلى تطوير الهوية البصرية واستراتيجيات التسويق. أركز على بناء علامات تجارية أصيلة ومميزة، تعكس جوهر المشروع وتخلق تواصلًا عميقًا مع الجمهور المستهدف.
                </p>
                <Link to="/book-consultation" className="inline-block bg-primary text-white hover:bg-primary-dark px-6 py-3 rounded-md font-medium transition duration-300">
                  طلب خدمة
                </Link>
              </div>

              {/* Service 4 */}
              <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition duration-300">
                <div className="text-primary text-4xl mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">دراسات الجدوى</h3>
                <p className="text-gray-600 mb-6">
                  أقدم دراسات جدوى شاملة ودقيقة للمشاريع، تتضمن تحليل السوق، والمنافسين، والجوانب المالية والتشغيلية. تساعد هذه الدراسات في اتخاذ قرارات مدروسة بشأن جدوى المشروع، وتحديد نقاط القوة والضعف، وتقييم المخاطر والفرص، مما يضع أساسًا متينًا للنجاح.
                </p>
                <Link to="/book-consultation" className="inline-block bg-primary text-white hover:bg-primary-dark px-6 py-3 rounded-md font-medium transition duration-300">
                  طلب دراسة جدوى
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Pricing Section */}
      {activeTab === 'pricing' && (
        <div className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-6">أسعار الخدمات</h2>
              <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-12">
                أقدم مجموعة متنوعة من الخدمات بأسعار تنافسية تناسب احتياجات مختلف المشاريع والميزانيات
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Price Card 1 */}
              <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200">
                <div className="text-primary text-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-center text-gray-900 mb-4">الاستشارات</h3>
                <div className="text-center mb-6">
                  <span className="text-4xl font-bold text-primary">1,000</span>
                  <span className="text-gray-600 text-xl"> ريال</span>
                  <span className="text-gray-500 block">للساعة</span>
                </div>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">استشارات في ريادة الأعمال</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">تخطيط وتصميم نماذج الأعمال</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">بناء الهياكل التنظيمية</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">تحديد الهوية وصياغة الرؤية</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <span className="text-gray-600">الاجتماعات خارج المدينة المنورة عبر الإنترنت</span>
                  </li>
                </ul>
                <div className="text-center">
                  <Link to="/book-consultation" className="inline-block w-full bg-primary text-white hover:bg-primary-dark px-6 py-3 rounded-md font-medium transition duration-300">
                    حجز استشارة
                  </Link>
                </div>
              </div>

              {/* Price Card 2 */}
              <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 transform md:scale-105 z-10">
                <div className="absolute top-0 right-0 bg-primary text-white px-4 py-1 rounded-tr-lg rounded-bl-lg text-sm font-bold">الأكثر طلباً</div>
                <div className="text-primary text-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-center text-gray-900 mb-4">دراسات الجدوى</h3>
                <div className="text-center mb-6">
                  <span className="text-4xl font-bold text-primary">3,700</span>
                  <span className="text-gray-600 text-xl"> - 17,500</span>
                  <span className="text-gray-500 block">ريال حسب القطاع والتعقيد</span>
                </div>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">تحليل شامل للسوق</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">دراسة المنافسين</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">تحليل الجوانب المالية</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">تقييم المخاطر والفرص</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">خطة عمل تنفيذية</span>
                  </li>
                </ul>
                <div className="text-center">
                  <Link to="/book-consultation" className="inline-block w-full bg-primary text-white hover:bg-primary-dark px-6 py-3 rounded-md font-medium transition duration-300">
                    طلب دراسة جدوى
                  </Link>
                </div>
              </div>

              {/* Price Card 3 */}
              <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200">
                <div className="text-primary text-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-center text-gray-900 mb-4">العلامة التجارية</h3>
                <div className="text-center mb-6">
                  <span className="text-4xl font-bold text-primary">3,575</span>
                  <span className="text-gray-600 text-xl"> - 13,500</span>
                  <span className="text-gray-500 block">ريال حسب نوع الخدمة</span>
                </div>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">تصميم الشعار: 3,575 ريال</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">الهوية البصرية الكاملة: 7,999 ريال</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">دراسة العلامة التجارية: 13,500 ريال</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">تحديد الهوية والقيم</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="h-5 w-5 text-primary ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-600">استراتيجيات التسويق</span>
                  </li>
                </ul>
                <div className="text-center">
                  <Link to="/book-consultation" className="inline-block w-full bg-primary text-white hover:bg-primary-dark px-6 py-3 rounded-md font-medium transition duration-300">
                    طلب خدمة
                  </Link>
                </div>
              </div>
            </div>

            {/* Additional Pricing Info */}
            <div className="mt-16 bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">ملفات تأسيس المشروع</h3>
              <p className="text-gray-600 mb-6 text-center">
                تتضمن ملفات تأسيس المشروع دراسة الجدوى بالإضافة إلى خطة العمل ونموذج العمل وملفات داعمة إن احتاج المشروع.
              </p>
              <div className="bg-white p-6 rounded-lg shadow-md mb-8">
                <div className="text-center mb-4">
                  <span className="text-3xl font-bold text-primary">7,900</span>
                  <span className="text-gray-600 text-xl"> - 25,375</span>
                  <span className="text-gray-500 block">ريال حسب القطاع والتعقيد</span>
                </div>
                <div className="text-center">
                  <Link to="/book-consultation" className="inline-block bg-primary text-white hover:bg-primary-dark px-6 py-3 rounded-md font-medium transition duration-300">
                    طلب ملفات تأسيس المشروع
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">هل تحتاج إلى مساعدة في مشروعك؟</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            سواء كنت تبدأ مشروعاً جديداً أو تطور مشروعاً قائماً، أنا هنا لمساعدتك في تحقيق رؤيتك وبناء مستقبل ناجح.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/book-consultation" className="bg-white text-primary hover:bg-gray-100 px-6 py-3 rounded-md font-medium transition duration-300">
              حجز استشارة
            </Link>
            <Link to="/contact" className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary px-6 py-3 rounded-md font-medium transition duration-300">
              تواصل معي
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
